export function axIsTypeUint(x) {
    return typeof x === "number" && ((x >>> 0) === x);
}
